<template>
	<div class="con">
		<div class="head">
			<van-tabs v-model="headActive" color="#27bec4" @change="headBtn">
				<van-tab title="住院"></van-tab>
				<van-tab title="门诊"></van-tab>
			</van-tabs>
		</div>
		<div class="list" v-if="list.length != ''">
			<div class="list-right">
				<div class="list-con" v-for="(item,index) in list" @click="toRegDeta(index)">
					<div class="text">{{item.KSMC}}</div>
					<van-icon name="arrow" color='#ccc' />
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">没有医生~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'communicationList',
		data() {
			return {
				msg: '通讯录',
				list: [],
				noImgShow: false,
				headActive: 0,
			}
		},
		methods: {
			//左边导航
			depa(e) {
				this.showIndex = e;
			},
			//类目详情
			toRegDeta(e) {
				let data = {
					ksdm: this.list[e].KSDM,
					ksmc: this.list[e].KSMC,
					mzks: this.list[e].MZKS
				}
				this.$router.push({
					path: 'communication',
					query: data
				})
			},
			//顶部导航
			headBtn(e) {
				this.headActive = e;
				this.GetOfficeSjks();
			},
			//获取下级科室信息 7-住院 8-门诊
			
			GetOfficeSjks() {
				this.$store.commit('Load', true)
				let URL;
				// if(this.headActive == 0){
				// 	URL = '/other/getOfficeSjks?sjks=7';
				// }else{
				// 	URL = '/outpatient/office?yjks=01';
				// }
				let stats = this.headActive + 7
				this.$Axios.Get('/collect/getOfficeSjks?sjks=' + stats, null).then(res => {
					this.$store.commit('Load', false)
					console.log(res)
					if(res.code == 0) {
						if(res.msg.length != 0) {
							this.list = res.msg;
						} else {
							this.noImgShow = true;
						}
					} else {
						this.noImgShow = true;
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					this.noImgShow = true;
					console.log(err)
				})
			},
		},
		mounted() {
			console.log(1)
			this.GetOfficeSjks();
		}
	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}
	.list-con {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 0;
		border-bottom: 1px solid #ccc;
	}
	.list {
		display: flex;
		font-size: 18px;
		flex: 1;
		overflow-y: scroll;
	}
	
	.list-left {
		width: 80px;
	}
	
	.list-right {
		padding: 5px;
		width: 100%;
		background-color: #fff;
	}
	
	
	.text {
		padding: 10px 5px;
		font-size: 16px;
	}
	
</style>